import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { SafeImage } from "@/components/SafeImage";

export default function Specials() {
  const [specials, setSpecials] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/specials")
      .then((r) => setSpecials(r.data))
      .catch(() => setSpecials([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section
      id="specials"
      data-testid="specials-section"
      className="trio-section py-24 lg:py-32 border-b border-[var(--trio-border)]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-14">
          <div className="lg:col-span-4">
            <div className="text-[11px] tracking-[0.3em] uppercase text-[var(--trio-primary)] font-bold mb-4">
              This Week at Trio
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-none">
              Daily &amp;<br />weekly specials.
            </h2>
          </div>
          <div className="lg:col-span-7 lg:col-start-6 self-end">
            <p className="text-base lg:text-lg text-[var(--trio-muted)] leading-relaxed">
              We rotate plates and pours throughout the week — these are the
              ones the regulars come back for. Flyers and promos drop here
              first.
            </p>
          </div>
        </div>

        <div
          data-testid="specials-grid"
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6"
        >
          {loading &&
            Array.from({ length: 4 }).map((_, i) => (
              <div
                key={i}
                className="aspect-[3/4] bg-[var(--trio-surface)] animate-pulse"
              />
            ))}
          {!loading &&
            specials.map((s, idx) => (
              <article
                key={s.id}
                data-testid={`special-card-${idx}`}
                className="group relative bg-[var(--trio-surface)] border border-[var(--trio-border)] hover:border-[var(--trio-primary)] transition-colors"
              >
                {s.image_url && (
                  <div className="relative overflow-hidden aspect-[4/3]">
                    <SafeImage
                      src={s.image_url}
                      alt={s.title}
                      className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                  </div>
                )}
                <div className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <span className="text-[10px] tracking-[0.25em] uppercase text-[var(--trio-primary)] font-bold">
                      {s.day}
                    </span>
                    {s.price && (
                      <span className="font-display text-xl">{s.price}</span>
                    )}
                  </div>
                  <h3 className="font-display uppercase text-2xl leading-tight tracking-tight mb-2">
                    {s.title}
                  </h3>
                  <p className="text-sm text-[var(--trio-muted)] leading-relaxed">
                    {s.description}
                  </p>
                </div>
              </article>
            ))}
          {!loading && specials.length === 0 && (
            <div className="col-span-full text-center py-12 text-[var(--trio-muted)]">
              No specials posted yet — check back soon.
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
